<template>
    <v-dialog
        v-model="dialog"
        persistent
    >

        <v-card>
            <v-card-actions>
                <v-btn
                    class="mx-2 button-position"
                    fab
                    dark
                    small
                    color="primary"
                    @click="closeModal"
                >
                    <v-icon dark>
                        mdi-minus
                    </v-icon>
                </v-btn>
            </v-card-actions>
            <v-card-text style="height: 600px">
                <deposit-list :convey-data-deposit="conveyDataDeposit" />
            </v-card-text>

        </v-card>
    </v-dialog>
</template>

<script>
import DepositList from "@/views/deposit/DepositList";
/**
 * 매출 확인 페이지에서 입출금 내역을 보여주기 위한 모달 입니다.
 */
export default {
    name: "DepositModal",
    props: {
        dialog: {
            type: Boolean,
            default: false
        },
        conveyDataDeposit:{
            type:Object,
            default:()=>{}
        }
    },
    components: {
        DepositList

    },
    methods: {
        closeModal() {
            this.$emit('close-modal')
        }
    },
}
</script>

<style scoped>
.button-position{
    position: absolute;
    top: 60px;
    right: 50px;
    z-index: 50;
}

>>>.v-dialog {
    overflow-y: visible;

}
>>>.v-dialog:not(.v-dialog--fullscreen) {
    max-height: none;

}
>>>.v-dialog .v-card .v-card__text{
    overflow-y: hidden;

}

</style>